var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTicket = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,0 L18.0011278,0 C19.1041846,0 19.9983888,0.90234375 19.9983888,1.99456145 L19.9983888,19.0054385 C19.9983888,20.1070044 19.1075352,21 18.0011278,21 L16,21 L11.9990333,21 L11.9990333,20.5008327 C11.9990333,19.6785455 11.3275145,19 10.4991541,19 C9.66501857,19 8.99927497,19.6719457 8.99927497,20.5008327 L8.99927497,21 L4.99830826,21 L2.99718044,21 C1.89412365,21 0.999919441,20.0976562 0.999919441,19.0054385 L0.999919441,1.99456145 C0.999919441,0.892995579 1.89077306,0 2.99718044,0 L4.99830826,0 L8.99927497,0 L8.99927497,0.499167264 C8.99927497,1.32145452 9.67079374,2 10.4991541,2 C11.3332897,2 11.9990333,1.3280543 11.9990333,0.499167264 L11.9990333,-2.77555756e-17 L16,0 Z M13.6621023,3 C13.0997857,4.18239956 11.892957,5 10.4991541,5 C9.1019295,5 7.8959447,4.18349232 7.33485091,3 L3.99967776,3 L3.99967776,18 L7.33620598,18 C7.89852254,16.8176004 9.10535129,16 10.4991541,16 C11.8963788,16 13.1023636,16.8165077 13.6634574,18 L16.9986305,18 L16.9986305,3 L13.6621023,3 Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 8,
  width: 3,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 8,
  width: 3,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 8,
  width: 3,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 8,
  width: 3,
  height: 2
})))));
export default SvgTicket;